import { getApiErrorMessage } from "./apiErrorMessage";

function isNoiseMessage(msg) {
  if (typeof msg !== "string") return true;
  const t = msg.trim().toLowerCase();
  return t === "" || t === "rejected";
}

/**
 * User-facing message from `dispatch(thunk()).unwrap()` catch value.
 * RTK throws `rejectWithValue` payload as-is (often a string). Using `error.message` on a string
 * yields undefined and can fall through to wrong text; serialized errors may show "Rejected".
 */
export function getThunkRejectMessage(err, fallback = "Something went wrong") {
  if (err == null) return fallback;
  if (typeof err === "string") {
    return isNoiseMessage(err) ? fallback : err.trim();
  }
  if (typeof err === "object") {
    const fromApi = getApiErrorMessage(err, "");
    if (!isNoiseMessage(fromApi)) return fromApi.trim();
    const p = err.payload;
    const fromPayload =
      typeof p === "string"
        ? p
        : p != null && typeof p === "object" && typeof p.message === "string"
          ? p.message
          : "";
    if (!isNoiseMessage(fromPayload)) return String(fromPayload).trim();
    const m = typeof err.message === "string" ? err.message : "";
    if (!isNoiseMessage(m)) return m.trim();
    return fallback;
  }
  return fallback;
}
